/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Left Accordion List Styles
 *
 * @file LeftAccordionListStyle.jsx
 * @author Murhsid Ahamedh
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../../assets/styles/mixins.scss';

export const CARD_SIDE_PADDING = 12; // matches CustomAccordion card padding

const useLeftAccordionListStyles = makeStyles({
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    padding: 16,

    [mixins['mlg-min']]: {
      padding: 0
    }
  },
  headerRowBaseStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'transparent',
    borderRadius: 0,
    padding: '10px 12px',
    cursor: 'pointer'
  },
  selectedBgStyle: {
    background: '#E8E6F3'
  },
  headerLeftStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  headerRightStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12
  },
  headerLabelTextStyle: {
    color: '#2E2E2E',
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize16,
    lineHeight: mixins.lineHeight24,
    letterSpacing: '0'
  },
  listStyle: {
    listStyle: 'none',
    margin: 0,
    padding: '12px 0 0 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  itemRowBaseStyle: {
    color: '#2E2E2E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: '8px 12px',
    borderRadius: 0
  },
  countChipStyle: {
    background: 'transparent',
    color: '#1D4ED8',
    border: '1px solid #CBD5E1',
    borderRadius: 9999,
    fontWeight: 700
  },
  emptyStateStyle: {
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: '#9CA3AF',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight150
  },
  doneIconStyle: {
    transform: 'rotate(0deg)',
    opacity: 1,
    fontSize: 28,
    color: '#2E2E2E'
  },
  topicTextBaseStyle: {
    color: '#2E2E2E',
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight150,
    letterSpacing: '0'
  },
  topicTextSelectedStyle: {
    color: '#2E2E2E',
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight150,
    letterSpacing: '0'
  },
  selectedItemStyle: {
    marginLeft: -CARD_SIDE_PADDING,
    marginRight: -CARD_SIDE_PADDING,
    padding: '8px 24px',
    borderRadius: 0
  },
  selectedHeaderStyle: {
    marginLeft: -CARD_SIDE_PADDING,
    marginRight: -CARD_SIDE_PADDING,
    padding: '10px 24px',
    borderRadius: 0
  }
});

export default useLeftAccordionListStyles;

